module.exports = __webpack_public_path__ + "static/media/dbs-bank-logo.010511b4.jpg";